import { withStyles } from '@material-ui/core'
import { ToggleButtonGroup } from '@material-ui/lab'
import { GRAY_COLORS } from '../../colors.constant'

export const AsterToggleButtonGroup = withStyles(theme => ({
  root: {
    padding: 4,
    border: `1px solid ${GRAY_COLORS[200]}`,
    borderRadius: 8
  }
}))(ToggleButtonGroup)
